
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://qzhtebnwqzwyxziaomrz.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF6aHRlYm53cXp3eXh6aWFvbXJ6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDU0NzMzNzEsImV4cCI6MjA2MTA0OTM3MX0.s4-ZWHsIZgS0wVl7J0nNx7ozXtIFa8aBrNW3rmZ5Ae4";

// Import the supabase client like this:
// import { supabase } from "../integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
